var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100 flex"},[_c('v-breadcrumbs',{staticClass:"dn db-ns",attrs:{"items":[
        {
          text: 'Bots',
          disabled: false,
          href: '/bots',
        },
        {
          text:
            (_vm.editBot &&
              _vm.editBot.configuration &&
              _vm.editBot.configuration.title) ||
            'Sem título',
          disabled: true,
          href: '',
        } ],"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{staticClass:"link",attrs:{"to":props.item.href}},[_c('a',{class:[props.item.disabled && 'v-breadcrumbs__item--disabled'],attrs:{"disabled":props.item.disabled}},[_vm._v("\n            "+_vm._s(props.item.text)+"\n          ")])])]}}])}),_c('div',{staticClass:"ml-auto mt-3 d-flex"},[_c('ButtonSave',{attrs:{"buttonClass":"mr2","tooltip":false,"bot":_vm.editBot}}),_c('ButtonEdit',{attrs:{"buttonClass":"mr2","tooltip":false,"bot":_vm.editBot}}),_c('ButtonActive',{attrs:{"buttonClass":"mr2","tooltip":false,"bot":_vm.editBot}}),_c('ButtonDeactivate',{attrs:{"buttonClass":"mr2","tooltip":false,"bot":_vm.editBot}})],1)],1),_c('PageEditContent',{attrs:{"bot":_vm.editBot}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }